import { RowModel } from 'app/shared/features/map-row-selector/models/server/row-model';

export interface Row {
    number: number;
    name: string;
}

export function mapModelToRow(model: RowModel | undefined): Row | undefined {
    return model
        ? {
              number: model.number,
              name: model.shortName?.trim() || model.name?.trim() || model.number.toString(),
          }
        : undefined;
}
